module.exports = __webpack_public_path__ + "static/media/ban-img3.2316a22f.png";